<!-- TrustBox widget - Carousel -->
<div
    *appFeatureFlag="'isTrustpilotAvailable'"
    #trustbox
    class="trustpilot-widget"
    data-locale="en-GB"
    data-template-id="53aa8912dec7e10d38f59f36"
    data-businessunit-id="6a9689d98716e8b55449b156"
    data-style-height="140px"
    data-style-width="100%"
    data-tags="identialert"
    data-stars="4,5"
    data-review-languages="en"
>
    <a
        href="https://uk.trustpilot.com/review/www.identi.pet"
        target="_blank"
        rel="noopener">
        Trustpilot
    </a>
</div>
<!-- End TrustBox widget -->
